import createInvoiceFieldMutation from './createInvoiceFieldMutation'

const useMarkAsPaid = createInvoiceFieldMutation({ paid: true }, 'markAsPaid')

export default useMarkAsPaid
